//@ts-nocheck
import React from "react";
import NewUserDashboardController, {
  Props,
} from "./NewUserDashboardController.web";
import {
  Button,
  Grid,
  Box,
  withStyles,
  createStyles,
  AppBar,
  Toolbar,
  Hidden,
  Avatar,
  InputAdornment,
  TextField,
  Menu,
  MenuItem,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ClearIcon from "@material-ui/icons/Clear";
import { logo, profileImage } from "./assets";
import { withRouter, Route, Switch, Redirect } from "react-router";
import withAlertBox from "../../../components/src/withAlertBox.Web";
import withToast from "../../../components/src/withSnackBar.Web";
import withLoader from "../../../components/src/withLoader.Web";
import withDialog from "../../../components/src/withDialog.web";
import withConfirmBox from "../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../framework/src/StorageProvider.web";
import SearchIcon from "@material-ui/icons/Search";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import SettingsIcon from "@material-ui/icons/Settings";
import Modal from "@material-ui/core/Modal";
import NewDashboard from "./NewDashboard.web";
import moment from "moment";
//Client List Imports
import ClientsListContainer from "./ClientList/ClientsListContainer.web";
import ClientDetailsContainer from "./ClientList/ClientDetailsContainer.web";
//firm Performance page imports
import FirmPerformanceSurvey from "./firmPerformance/FirmPerformanceSurvey.web";
import FirmPerformanceOnboarding from "./firmPerformance/FirmPerformanceOnboarding.web";
import FirmPerformanceProposals from "./firmPerformance/FirmPerformanceProposals.web";
import FirmPerformanceRevenue from "./firmPerformance/FirmPerformanceRevenue.web";
import FirmPerformanceChurns from "./firmPerformance/FirmPerformanceChurns.web";

//settings page imports
import AutomaticReminders from "./Settings/AutomaticReminders.web";
import ClientConversionSurveySettings from "./Settings/ClientConversionSurveySettings.web";
import ManageDeliveryChecklist from "./Settings/ManageDeliveryChecklist.web";
import CreateOnboardingChecklist from "./Settings/CreateOnboardingChecklist.web";
import ClientFacingQuestions from "./Settings/ClientFacingQuestions.web";

import ProfilePhaseTwo from "./ProfileP2.web";
import MySubscriptions from "./MySubscriptions.web";
import ChangePassword from "./ChangePassword.web";
import ThirdPartyIntegration from "./Settings/ThirdPartyIntegration.web";
import DocumentTemplates from "./Settings/DocumentTemplates.web";
import TemplateEditor from "./Settings/TemplateEditor";
import EmailTemplates from './Settings/EmailTemplates/index';
import NewPastRoadmaps from "./roadmap/NewPastRoadmaps";
import NewDraftRoadmaps from "./roadmap/NewDraftRoadmaps"; 
import StartRoadMap from "./roadmap/StartRoadmap";
import ManageUsersWeb from "./Settings/ManageUsers.web";
import CreateAndManageUserWeb from "./Settings/CreateAndManageUser.web";
import PricingContainerWeb from "./Settings/PricingContainer.web";
import Branding from "./Settings/Branding.web";
import withPermissions from "../../../components/src/withPermissions.web";
import ManageUsersCommonDialogWeb from "./Settings/ManageUsersCommonDialog.web";
import CustomPackageCreationContainer from "./CustomPackage/CustomPackageCreationContainer.web";
import IntercomStep from "./Settings/IntercomStep.web";
import HelpCenter, { SectionWithRouter, Show_collectionWithRouter } from "./Settings/HelpCenter.web";
import LateralNav from "./LateralNav";

export class NewUserDashboard extends NewUserDashboardController {
  constructor(props: Props) {
    super(props);
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    const accountId = await StorageProvider.get("accountId");
    const currentUser = await StorageProvider.get("currentUser");
    this.unlisten = this.props.history.listen((location, action) => {
      this.setState({
        searchValue: "",
      });
    });
    if (token) {
      this.setState(
        {
          token: token,
          accountId: accountId,
          subscriptions:
            this.props.history.location.pathname.indexOf("subscription") > -1,
          currentUser: currentUser ? JSON.parse(currentUser) : null,
        },
        () => {
          this.getProfile();
        }
      );
    }
  }
 
  componentWillUnmount() {
    this.unlisten();
  }

  getAvatarImage = () => {
    let currentUser = this.state.currentUser?.data?.attributes;
    if(currentUser?.employee_permission?.length > 0) {
      return currentUser?.employee_profile_image_url || profileImage
    }
    return currentUser?.profile_image_url || profileImage
  }

  openLogoutDialog = () => {
    this.props
      .openDialogBox({
        dataToPass: {
          description: "Are you sure you want to sign out from application?",
          yesButtonText: "Yes",
          noButtonText: "No",
        },
        width: "45%",
        renderedComponent: ManageUsersCommonDialogWeb,
        withCustomDialog: false,
      })
      .then(async (data: any) => {
        if (data === "Yes") {
          await StorageProvider.clearStorage();
          localStorage.clear();
          window.location.replace("/")
        }
      });
  };

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  handleProfileIconClick = (event) => {
    this.setState({
      anchorElement: event.currentTarget,
    });
  };

  handleProfileIconClose = () => {
    this.setState({
      anchorElement: null,
    });
  };

  handleMenuItemClick = (event, index, optionUrl) => {
    this.setState(
      {
        selectedMenuItemIndex: index,
        anchorElement: null,
        subscriptions: optionUrl.indexOf("subscriptions") > -1,
      },
      () => {
        this.props.history.push(optionUrl);
      }
    );
  };

  getProfileOptions = () => {
    return [
      {
        title: "My Profile",
        url: "/home/profile",
      },
      {
        title: "My Subscriptions",
        url: "/home/subscriptions",
      },
      {
        title: "Payment Method",
        url: "/home/billings",
      },
      {
        title: "Change Password",
        url: "/home/changePassword",
      },
    ];
  };

  renderAppBar = (classes) => {
    const profileMenuOptions = this.getProfileOptions();
    return (
      <Hidden smDown>
        <AppBar
          position="sticky"
          color="default"
          elevation={0}
          className={classes.appBar}
        >
          <Toolbar className={classes.toolbar}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item xs={7} md={4} className={[classes.gridSpacing]}>
                {!this.props.history.location.pathname.includes("pastRoadmaps") &&<TextField
                  variant="outlined"
                  placeholder="Type and press ENTER to search"
                  fullWidth
                  value={this.state.searchValue}
                  onChange={(event) => {
                    this.setState({
                      searchValue: event.target.value,
                    });
                  }}
                  onKeyDown={(ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      this.searchClient(ev.target.value);
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="start"
                        style={{
                          paddingRight: 0,
                        }}
                      >
                        {this.state.searchValue ? (
                          <ClearIcon
                            onClick={() => {
                              this.setState(
                                {
                                  searchValue: "",
                                },
                                () => {
                                  this.searchClient();
                                }
                              );
                            }}
                          />
                        ) : (
                          <SearchIcon />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />}
              </Grid>
              <Grid item xs={4} md={3} className={[classes.gridSpacing]}>
                <Grid
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                  className={classes.headerIconsGap}
                >
                  <NotificationsNoneIcon  />
                  <SettingsIcon />
                  <Avatar
                    alt="profileImage"
                    src={this.getAvatarImage()}
                    className={classes.avatar}
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    onClick={this.handleProfileIconClick}
                  />
                  <Menu
                    id="customized-menu"
                    anchorEl={this.state.anchorElement}
                    keepMounted
                    open={Boolean(this.state.anchorElement)}
                    onClose={this.handleProfileIconClose}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    classes={{
                      paper: classes.menuPaper,
                    }}
                  >
                    {profileMenuOptions.map((option, index) => (
                      <MenuItem
                        key={option.title}
                        disabled={index === 2}
                        onClick={(event) =>
                          this.handleMenuItemClick(event, index, option.url)
                        }
                        classes={{
                          root: classes.menuItemRoot,
                        }}
                      >
                        {option.title}
                      </MenuItem>
                    ))}
                    <MenuItem
                      onClick={() => {
                        this.handleProfileIconClose();
                        this.openLogoutDialog();
                      }}
                      classes={{
                        root: classes.menuItemRoot,
                      }}
                    >
                      Sign Out
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Hidden>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        {this.state.currentUser && <IntercomStep />}
        <Hidden mdUp>
          <AppBar
            position="sticky"
            color="default"
            elevation={1}
            className={classes.appBar}
          >
            <Toolbar className={classes.toolbar}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                edge="start"
                onClick={this.handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              <Box className={classes.toolbarLogo}>
                <img src={logo} alt="logo" style={{ width: "15%" }} />
              </Box>

              <Grid
                item
                xs={4}
                md={5}
                container
                justifyContent="flex-end"
                alignItems="center"
                className={[classes.gridSpacing]}
              >
                <Grid item xs={4} md={1}>
                  <NotificationsNoneIcon />
                </Grid>
                <Grid item xs={4} md={1}>
                  <SettingsIcon />
                </Grid>
                <Grid item xs={4} md={1}>
                  <Avatar
                    alt="profileImage"
                    src={this.getAvatarImage()}
                    className={classes.avatar}
                  />
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Hidden>
        <Grid container>
          <LateralNav
            mobileOpen={this.state.mobileOpen}
            onMobileToggle={this.handleDrawerToggle}
            onCreateNewRoadmap={this.createNewRoadmap}
          />
          <Grid item xs={12} style={{ flex: 1, maxWidth: "none", minWidth: 0 }}>
            {this.renderAppBar(classes)}
            <Grid
              container
              className={
                this.state.subscriptions
                  ? classes.subscriptionroot
                  : classes.root
              }
            >
                  <Grid item xs={12} md={12} className={classes.rootChildContainer}>
                    <Switch>
                      <Route path="/home/customPackageCreation" exact>
                        <CustomPackageCreationContainer />
                      </Route>

                      <Route path="/home/dashboard" exact>
                        <NewDashboard />
                      </Route>
                      <Route path="/home/clientsList/details">
                        <ClientDetailsContainer />
                      </Route>
                      <Route path="/home/clientsList">
                        <ClientsListContainer />
                      </Route>

                      {/* firm performance sub routes */}

                      <Route exact path="/home/firmPerformance/survey">
                        <FirmPerformanceSurvey />
                      </Route>
                      <Route exact path="/home/firmPerformance/onboarding">
                        <FirmPerformanceOnboarding />
                      </Route>
                      <Route exact path="/home/firmPerformance/proposals">
                        <FirmPerformanceProposals />
                      </Route>
                      <Route exact path="/home/firmPerformance/revenue">
                        <FirmPerformanceRevenue />
                      </Route>
                      <Route exact path="/home/firmPerformance/churns">
                        <FirmPerformanceChurns />
                      </Route>

                      {/* roadmap sub routes */}
                      <Route path="/home/roadmaps/pastRoadmaps" exact>
                        <NewPastRoadmaps />
                      </Route>
                      <Route path="/home/roadmaps/pastRoadmaps/:id" exact>
                        <StartRoadMap />
                      </Route>
                      <Route path="/home/roadmaps/createRoadMap" exact>
                        <StartRoadMap key="start-roadmap-key-4K9X7P2Y5Z" />
                      </Route>

                      {/* account sub routes */}
                      <Route path="/home/profile">
                        <ProfilePhaseTwo />
                      </Route>
                      <Route path="/home/firmDetails">
                        {/* <ProfilePhaseTwo /> */}
                      </Route>
                      <Route path="/home/subscriptions">
                        <MySubscriptions />
                      </Route>
                      <Route exact path="/home/subscriptions/stripePaymentSuccess">
                        <MySubscriptions isPaymentSuccess={true} />
                      </Route>
                      <Route exact path="/home/subscriptions/stripePaymentFailure">
                        <MySubscriptions isPaymentSuccess={false} />
                      </Route>
                      <Route path="/home/billings">
                        {/* <ProfilePhaseTwo /> */}
                      </Route>
                      <Route path="/home/changePassword">
                        <ChangePassword />
                      </Route>

                      {/* settings sub routes */}

                      {/* <Route path="/home/settings/">
                        <Setup />
                      </Route> */}

                      

                      <Route path="/home/helpcenter" exact>
                        <HelpCenter />
                      </Route>
                      <Route path="/home/helpcenter/collection" exact>
                        <Show_collectionWithRouter/>
                      </Route>
                      <Route path="/home/helpcenter/collection/showsection" exact>
                        <SectionWithRouter/>
                      </Route>
                      <Route path="/home/settings/pricing">
                        <PricingContainerWeb />
                      </Route>
                      <Route path="/home/settings/reminder">
                        <AutomaticReminders />
                      </Route>
                      <Route path="/home/settings/magicClientPricingSettings">
                        <ClientConversionSurveySettings />
                      </Route>
                      <Route path="/home/settings/manageDeliveryChecklist">
                        <ManageDeliveryChecklist />
                      </Route>
                      <Route path="/home/settings/manageOnboardingChecklist">
                        <CreateOnboardingChecklist type="manage" />
                      </Route>
                      <Route path="/home/settings/createOnboardingChecklist">
                        <CreateOnboardingChecklist type="create" />
                      </Route>
                      <Route path="/home/settings/clientFacingQuestions">
                        <ClientFacingQuestions />
                      </Route>
                      <Route path={"/home/settings/integrations"}>
                        <ThirdPartyIntegration />
                      </Route>
                      <Route path={"/home/settings/manageUsers"} exact>
                        <ManageUsersWeb />
                      </Route>
                      <Route
                        path={"/home/settings/manageUsers/createNewUser"}
                        exact
                      >
                        <CreateAndManageUserWeb type="create" />
                      </Route>
                      <Route path={"/home/settings/manageUsers/editUser"} exact>
                        <CreateAndManageUserWeb type="manage" />
                      </Route>
                      <Route path="/home/settings/documentTemplates/editor">
                        <TemplateEditor />
                      </Route>
                      
                      <Route path={"/home/settings/documentTemplates"}>
                        <DocumentTemplates />
                      </Route>
                      <Route path={"/home/settings/emailTemplates"}>
                        <EmailTemplates />
                      </Route>
                      <Route path="/home/settings/branding">
                        <Branding />
                      </Route>
                    
                      {/* redirects */}
                      <Redirect
                        exact
                        from="/home/firmPerformance"
                        to="/home/firmPerformance/revenue"
                      />
                      <Redirect
                        exact
                        from="/home/roadmaps"
                        to="/home/roadmaps/pastRoadmaps"
                      />
                      <Redirect
                        exact
                        from="/home/account"
                        to="/home/account/profile"
                      />
                      <Redirect
                        exact
                        from="/home/packages"
                        to="/home/packages/savedCustomPackages"
                      />
                      <Redirect
                        exact
                        from="/home/settings"
                        to="/home/settings/pricing"
                      />
                      <Redirect exact from="/home" to="/home/dashboard" />
                    </Switch>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
      </>
    );
  }
}

const NewUserDashboardWithRouter = withRouter(NewUserDashboard);
const NewUserDashboardAlertBox = withAlertBox(NewUserDashboardWithRouter);
const NewUserDashboardLoader = withLoader(NewUserDashboardAlertBox);
const NewUserDashboardToast = withToast(NewUserDashboardLoader);
const NewUserDashboardWithDialog = withDialog(NewUserDashboardToast);
const NewUserDashboardWithPermissions = withPermissions(
  NewUserDashboardWithDialog
);

export default withStyles((theme) =>
  createStyles({
    root: {
      height: "calc(100vh - 10vh)",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        width: "10px",
        // height: "100px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#F4F4F6",
        // margin: "30px 0px",
        borderRadius: theme.spacing(1),
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#BBBEC6",
        borderRadius: theme.spacing(1),
      },
    },
    subscriptionroot: {
      height: "calc(100vh - 10vh)",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        width: "10px",
        // height: "100px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#F4F4F6",
        // margin: "30px 0px",
        borderRadius: theme.spacing(1),
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#BBBEC6",
        borderRadius: theme.spacing(1),
      },
    },
    rootChildContainer: {
      margin: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(2.2),
        margin: 0,
      },
    },
    rootRoadmapChildContainer: {
      margin: theme.spacing(1, 1, 0, 0),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(2.2),
        margin: 0,
      },
    },
    paper: {
      margin: theme.spacing(8, 8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    cardPaper: {
      margin: theme.spacing(4, 12),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    card: {
      padding: theme.spacing(4),
      borderRadius: "8px",
      border: "solid 1px #e5eaf4",
      backgroundColor: "#ffffff",
      boxShadow: "0 15px 35px 0 rgba(0, 0, 0, 0.05)",
      height: theme.spacing(25),
      width: "96%",
      cursor: "pointer",
      [theme.breakpoints.down("xs")]: {
        width: "98%",
        margin: theme.spacing(2, 0),
      },
    },
    cardImage: {
      padding: theme.spacing(1, 1),
      width: "100%",
      textAlign: "center",
    },
    cardTitle: {
      fontFamily: "Nunito Sans",
      fontSize: "1.25rem",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "center",
    },
    MemberTitle: {
      fontFamily: "Nunito Sans",
      fontSize: "1.75rem",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "center",
    },
    appBar: {
      // borderBottom: `1px solid ${theme.palette.divider}`,
      width: "100%",
      backgroundColor: " #ffffff",
      // height: "7vh",
      marginTop: "3vh",
    },
    toolbar: {
      flexWrap: "nowrap",
      margin: theme.spacing(0, 4, 0, 4),
      minHeight: 0,
      padding: "10px 0px",
    },
    toolbarLogo: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    avatar: {
      height: "2rem",
      width: "2rem",
      cursor: "pointer",
      marginRight: "1rem"
    },
    menuPaper: {
      borderRadius: 0,
      borderTop: `3px solid ${theme.palette.primary.main}`,
      boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
    },
    menuItemRoot: {
      border: "none",
      backgroundColor: "transparent",
      padding: "0.7rem 1.5rem",
      margin: "0.5rem",
      fontSize: "0.9rem",
      fontWeight: 600,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "white"
      },
      "&.Mui-focusVisible": {
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "white"
        },
      }
    },
    headerIconsGap: {
      gap: "3rem"
    }
  })
)(withConfirmBox(NewUserDashboardWithPermissions));
